var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99451 7.94015V1.00004C6.99451 1.00004 6.98003 0.998047 6.96656 0.998047C3.11566 0.998047 0 4.1197 0 7.97059C0 11.8225 3.12514 14.9192 6.97604 14.9192C10.8209 14.9192 13.9416 11.9333 13.9516 7.94015H6.99451Z",
    fill: "#797979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9502 6.9401C14.9502 6.9401 14.9383 6.95258 14.9383 6.94609C14.9383 3.10867 11.9863 0.0219623 7.99316 0V6.9396H14.9502V6.9401Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportChartIcon);
export default __webpack_public_path__ + "static/media/report_chart_icon.4a5c5a0564b43fff39b8adac0ddd5e2e.svg";
export { ForwardRef as ReactComponent };